module.exports = __webpack_public_path__ + "static/proszek_sloik@0,5x-b47fafabc0cb4323effbbb587813f4ec.png";